

import { useEffect, useMemo, useRef, useContext } from "react"
import { GenerateContext } from "@utils/GenerateContext"

const PAINT_COLOR = 'rgba(30, 144, 255, 0.8)'
const ERASE_COLOR = 'rgb(255, 255, 255)'

fabric.PencilBrushCustom = fabric.util.createClass(fabric.PencilBrush, {
    createPath: function (pathData) {
        const path = new fabric.Path(pathData, {
            fill: null,
            stroke: this.color == 'rgba(0,0,0,0)' ? ERASE_COLOR : this.color,
            strokeWidth: this.width,
            strokeLineCap: this.strokeLineCap,
            strokeMiterLimit: this.strokeMiterLimit,
            strokeLineJoin: this.strokeLineJoin,
            strokeDashArray: this.strokeDashArray,
            globalCompositeOperation: this.color == 'rgba(0,0,0,0)' ? 'destination-out' : 'source-over',
            selectable: false,
            hoverCursor: 'pointer',
            evented: false,
        });
        if (this.shadow) {
            this.shadow.affectStroke = true;
            path.shadow = new fabric.Shadow(this.shadow);
        }

        return path;
    },
})

const usePaint = (fabricInstanceRef, pencilBrushRef, circleMouseRef, drawTypeRef, moveableRef, ctrlPressedRef, props, saveToUndoList) => {
    const drawingRef = useRef()
    const tempPathRef = useRef()
    const modeRef = useRef('paint')
    const paintSizeRef = useRef(20)
    const eraserSizeRef = useRef(20)
    const canvasContainer = document.querySelector('.replace_canvas');
    const { modeState, paintSize, eraserSize } = useContext(GenerateContext)


    useEffect(() => {
        modeRef.current = modeState
    }, [modeState])

    useEffect(() => {
        paintSizeRef.current = paintSize
        eraserSizeRef.current = eraserSize
    }, [paintSize, eraserSize])

    useEffect(() => {
        if (!fabricInstanceRef.current) return
        // 初始画笔
        const brush = new fabric.PencilBrushCustom(fabricInstanceRef.current)
        pencilBrushRef.current = brush
        // brush.color = 'rgba(30, 144, 255, 0.8)'
        brush.color = modeState == 'paint'? 'rgba(30, 144, 255, 0.8)': 'rgba(0,0,0,0)'
        brush.width =  modeState == 'paint'?  paintSize: eraserSize
        brush.limitedToCanvasSize = true
        fabricInstanceRef.current.isDrawingMode = true
        fabricInstanceRef.current.freeDrawingBrush = pencilBrushRef.current
        fabricInstanceRef.current.freeDrawingCursor = 'pointer'

        // 画笔位置
        const circle = new fabric.Circle({
            left: 0,
            top: 0,
            radius: (modeState == 'paint'?  paintSize: eraserSize) / 2,
            fill: modeState == 'paint'?'rgba(30, 144, 255, 0.5)': 'rgba(255, 255, 255, 0.5)',
            // strokeWidth: 2,
            // stroke: modeState == 'paint'? 'rgba(30, 144, 255, 0.8)': 'rgba(255, 255, 255, 0.8)',
            originX: 'center',
            originY: 'center',
            hasControls: false,
            hasBorders: false,
            selectable: false,
        })
        circleMouseRef.current = circle
    }, [fabricInstanceRef.current, modeState, paintSize, eraserSize])

    useEffect(() => {
        if (!pencilBrushRef.current) return
        fabricInstanceRef.current.on('mouse:down', (event) => {
            if (moveableRef.current) return
            if (drawTypeRef.current === 'draw') {
                drawingRef.current = true;
            }
        })
        fabricInstanceRef.current.on('mouse:move', (event) => {
            if (drawTypeRef.current === 'draw') {
                updatePathPosition(event);
                if (modeRef.current == 'eraser') {
                    if (!drawingRef.current) return

                    if (tempPathRef.current) fabricInstanceRef.current.remove(tempPathRef.current)
                    let _points = []
                    if (pencilBrushRef.current.decimate) {
                        _points = pencilBrushRef.current.decimatePoints(pencilBrushRef.current._points, pencilBrushRef.current.decimate);
                    }
                    if (_points.length == 0) return
                    const pathData = pencilBrushRef.current.convertPointsToSVGPath(_points);
                    if (pencilBrushRef.current._isEmptySVGPath(pathData)) {
                        return
                    }
                    const tempPath = new fabric.Path(pathData, {
                        fill: null,
                        stroke: modeRef.current == 'eraser' ? ERASE_COLOR : PAINT_COLOR,
                        strokeWidth: modeRef.current == 'eraser' ? eraserSizeRef.current : paintSizeRef.current,
                        strokeLineCap: 'round',
                        strokeMiterLimit: 10,
                        strokeLineJoin: 'round',
                        strokeDashArray: null,
                        globalCompositeOperation: modeRef.current == 'eraser' ? 'destination-out' : 'source-over',
                        selectable: false,
                        hoverCursor: 'pointer',
                        evented: false,
                    })
                    tempPathRef.current = tempPath
                    fabricInstanceRef.current.add(tempPath)
                    fabricInstanceRef.current.requestRenderAll()
                }
            }
        })
        fabricInstanceRef.current.on('mouse:up', () => {
            if (drawTypeRef.current === 'draw') {
                if (!modeRef.current) return
                if (tempPathRef.current) {
                    fabricInstanceRef.current.remove(tempPathRef.current)
                    fabricInstanceRef.current.renderAll()
                }
                pencilBrushRef.current._reset() // 清除path
                drawingRef.current = false
            }
        })
        fabricInstanceRef.current.on('path:created', ({ path }) => {
            path.set({ selectable: false })
            saveToUndoList()
        })
        fabricInstanceRef.current.on('mouse:wheel', function (event) {
            if (!circleMouseRef.current) return
            if (!ctrlPressedRef.current) return

            event.e.preventDefault();
            event.e.stopPropagation();

            const delta = event.e.deltaY;
            // 根据滚轮滚动方向调整缩放比例
            if (delta > 0) {
                props.changeBrushSize(-1)
            } else {
                props.changeBrushSize(1)
            }
        })

        if (canvasContainer) {
            canvasContainer.addEventListener('mouseenter', handleMouseEnter);
            canvasContainer.addEventListener('mouseleave', handleMouseLeave);
        }
        return () => {
            if (canvasContainer) {
                canvasContainer.removeEventListener('mouseleave', handleMouseLeave);
                canvasContainer.removeEventListener('mouseenter', handleMouseEnter);
            }
        }
    }, [fabricInstanceRef.current])


    
    // 鼠标移出事件，隐藏圆形画笔
    const handleMouseLeave = () => {
        if (circleMouseRef.current && fabricInstanceRef.current.contains(circleMouseRef.current)) {
            fabricInstanceRef.current.remove(circleMouseRef.current);
        }
    };

    // 鼠标移入事件，显示圆形画笔
    const handleMouseEnter = () => {
        if (!circleMouseRef.current || drawTypeRef.current != 'draw') return;
        const circleRef = Array.isArray(circleMouseRef.current)
            ? circleMouseRef.current.find((item) => item.type === 'circle')
            : circleMouseRef.current;

        if (circleRef && !fabricInstanceRef.current.contains(circleRef)) {
            fabricInstanceRef.current.add(circleRef);
            // console.log('circleRef进入', circleRef)
            fabricInstanceRef.current.bringToFront(circleRef);
        }
    };
    // 组件卸载
    useEffect(() => {
        return () => {
            if (fabricInstanceRef.current) {
                fabricInstanceRef.current.off('mouse:down');
                fabricInstanceRef.current.off('mouse:move');
                fabricInstanceRef.current.off('mouse:up');
            }
        };
    }, []);

    // 更新涂抹圆形的画笔位置
    const updatePathPosition = (event) => {
        if (!fabricInstanceRef.current || !circleMouseRef.current) return;

        const { offsetX, offsetY } = event.e;

        const canvasOffsetX = fabricInstanceRef.current.viewportTransform[4];
        const canvasOffsetY = fabricInstanceRef.current.viewportTransform[5];
        const pathZoom = fabricInstanceRef.current.getZoom();

        const x = (offsetX - canvasOffsetX) / pathZoom;
        const y = (offsetY - canvasOffsetY) / pathZoom;
        // console.log('circleMouseRef.current', circleMouseRef.current.radius)
        if (Array.isArray(circleMouseRef.current) && circleMouseRef.current) {
            circleMouseRef.current.find(item => item.type == 'circle').set({
                left: x,
                top: y,
            });
            circleMouseRef.current.bringToFront()
        } else {
            circleMouseRef.current.set({
                left: x,
                top: y,
            });
            circleMouseRef.current.bringToFront()
        }
        fabricInstanceRef.current.renderAll();
    };
}

export default usePaint